export var date = function date(node) {
  var addLeadingZero = function addLeadingZero(val) {
    if (val < 10) {
      return "0".concat(val);
    }
    return val;
  };
  var result = new Date(Number(node.attrs.timestamp));
  return "{{".concat(result.getUTCFullYear(), "-").concat(addLeadingZero(result.getUTCMonth() + 1), "-").concat(addLeadingZero(result.getUTCDate()), "}}");
};